import React from 'react';
import { useTranslation } from 'react-i18next';
import FormFileUpload from '../../../../../../antd/form/FormFileUpload/FormFileUpload.jsx';
import { required } from '../../../../../../antd/form/FormValidation.js';
import {Row, Col, Alert} from 'antd';

const RequiredDocuments = ({ onPreview, isPreview }) => {
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <FormFileUpload
            label={t('Životopis')}
            name={'cv_path'}
            rules={[required(t)]}
            accept=".pdf"
            hintText={t('Maximálna veľkosť súboru je 10 MB vo formáte .pdf')}
            onPreview={onPreview}
            disabled={isPreview}
          />
        </Col>
        <Col span={12}>
          <FormFileUpload
            label={t('Motivačný list')}
            name={'motivation_letter_path'}
            rules={[required(t)]}
            accept=".pdf"
            hintText={t('Maximálna veľkosť súboru je 10 MB vo formáte .pdf')}
            onPreview={onPreview}
            disabled={isPreview}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <FormFileUpload
            label={t('Jazykový certifikát')}
            name={'language_certificate_path'}
            accept=".pdf"
            hintText={t('Maximálna veľkosť súboru je 10 MB vo formáte .pdf')}
            onPreview={onPreview}
            disabled={isPreview}
          />
        </Col>
        <Col span={12}>
          <FormFileUpload
            label={t('Fotografia')}
            name={'photo_path'}
            rules={[required(t)]}
            accept=".jpg,.jpeg,.png"
            hintText={t(
              'Maximálna veľkosť súboru je 5 MB vo formáte .jpg .jpeg .png',
            )}
            onPreview={onPreview}
            disabled={isPreview}
          />
        </Col>
      </Row>
      <Alert
        title={t('Pokyny pre fotografiu: Pozadie biele alebo svetlé. Hlava a ramená 70 - 80% fotografie. Fotografia musí byť aktuálna, nie staršia ako 6 mesiacov')}
        type="info"
        showIcon
        style={{ marginBottom: 10 }}
      />
    </>
  );
};

export default RequiredDocuments;
